<template>
	<div class="scoped-headhunter" v-if="firstRendered">
		<div class="">
			<div class="filter-condition box-shadow-small border-radius">
				<div class="search-box">
					<el-button class="search-hd" type="primary" icon="el-icon-search"
							   @click="searchKeyword(keyword)"></el-button>
					<div class="search-bd">
						<search-bar v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"
									placeholder="请输入供应商名称" :ajaxSearch="false"></search-bar>
					</div>
				</div>
				<!--<filter-panel @params-change="getParams" ref="condition">-->
				<!--<filter-panel-item v-for="(item, index) in filterConf" :label="item.label" :mode="item.mode"-->
				<!--:name="item.name" :data="item.data" :key="index"-->
				<!--:initValue="item.value"></filter-panel-item>-->
				<!--</filter-panel>-->
			</div>
			<div class="filter-result background-white box-shadow-small border-radius">
				<div v-loading="partialLoading">
					<empty-tip :show="!lists.length"></empty-tip>
					<el-table v-if="lists.length" :data="lists" border>
						<el-table-column align="left" prop="supplierName" label="供应商名称" width="180"></el-table-column>
						<el-table-column align="center" prop="resumeTotal" label="简历推荐数"></el-table-column>
						<el-table-column align="center" prop="resumePass" label="简历通过"></el-table-column>
						<el-table-column align="center" prop="resumeNotPass" label="简历不通过"></el-table-column>
						<el-table-column align="center" prop="resumeUndetermined" label="简历待定"></el-table-column>
						<el-table-column align="center" prop="resumeBlack" label="简历拉黑"></el-table-column>
						<el-table-column align="center" prop="paperPass" label="笔试通过"></el-table-column>
						<el-table-column align="center" prop="paperNotPass" label="笔试不通过"></el-table-column>
						<el-table-column align="center" prop="paperUndetermined" label="笔试待定"></el-table-column>
						<el-table-column align="center" prop="paperBlack" label="笔试拉黑"></el-table-column>
						<el-table-column align="center" prop="interviewPass" label="面试通过"></el-table-column>
						<el-table-column align="center" prop="interviewNotPass" label="面试不通过"></el-table-column>
						<el-table-column align="center" prop="interviewUndetermined" label="面试待定"></el-table-column>
						<el-table-column align="center" prop="interviewBlack" label="面试拉黑"></el-table-column>
						<el-table-column align="center" prop="offer" label="offer"></el-table-column>
						<el-table-column align="center" prop="breakPromise" label="毁约"></el-table-column>
						<el-table-column align="center" prop="entry" label="入职"></el-table-column>
					</el-table>
					<el-pagination
							v-if="lists.length"
							class="text-center mb-20 mt-10"
							@size-change="pageSizeChange"
							@current-change="pageIndexChange"
							:current-page="pagination.pageIndex"
							:page-size="pagination.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pagination.recordCounts">
					</el-pagination>
				</div>
			</div>
		</div>
		<EditSupplierDialog ref="editSupplier" @reload="fetchData"></EditSupplierDialog>
	</div>
</template>

<script type="text/javascript">
    import ListItem from './listItem'
    import EditSupplierDialog from './editSupplierDialog'
    import QueryListExtend from 'components/queryListExtend'

    export default {
        'extends': QueryListExtend,
        data () {
            return {
                fetchUrl: '/supplier/getResumeStatistics.api',
                filterConf: [
                    {
                        label: '签约部门',
                        name: 'dbTypeSearch',
                        filter: 'SYS_TYPE',
                        data: []
                    }
                ],
                searchData: {
                    searchWord: null
                }
            }
        },
        methods: {
            showEditWin (data) {
                this.$refs.editSupplier.show(true, data)
            },
            getSourceName (code) {
                let data = this.companyList.filter(item => item.code === code)
                return data.length ? data[0].name : '-'
            },
            extendParamsBeforeFetch () {
                return {
                    supplierName: this.searchData.searchWord
                }
            }
        },
        components: {
            ListItem,
            EditSupplierDialog
        }
    }
</script>

<style type="text/css" lang="scss">
	@import "~variable";

	.scoped-headhunter {
		.filter-result {
			margin : 20px 0;
			.list-item {
				&-bottom {
					background : $background-color;
				}
				&:not(:first-child) {
					margin-top : 20px;
				}
				.line-text-1, .line-text-2 {
					margin : 5px 0;
				}
				&-body {
					.operate-btn-area {
						button {
							display     : block;
							width       : 100%;
							margin-left : 0;
							&:not(:first-child) {
								margin-top : 5px;
							}
						}
					}
				}
			}
			.title {
				font-size : 16px;
			}
			.c-tips {
				color : #999;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// statistic.vue?bbf4d00c